import * as CIActions from 'ApplicationEntry/ducks/ProductsRiders/criticalIllness';
import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {isLoaded, isLoading, PlanModel} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import * as ErrorMessages from '../ErrorMessages';
import './ProductRiders.sass';

import {CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, Select} from '@material-ui/core';
import {StringUnion} from 'Core/models/EmptyString';

type PlanSelectProps = {
  productType: StringUnion;
  productList: PlanModel;
  family: string;
  applicationType: ApplicationType;
  friendlyName: string;
  getPlansAction: (plan: string) => void;
  changePlanAction: (plan: string) => void;
};

const PlanSelect = ({
  productList,
  productType,
  family,
  applicationType,
  friendlyName,
  getPlansAction,
  changePlanAction,
}: PlanSelectProps) => {
  const dispatch = useDispatch();

  const [productBlurred, setBlurProduct] = useState(false);
  const showProductError = productBlurred && productType.key === 'Empty';
  const [productLabel, setProductLabel] = useState<HTMLLabelElement | null>();

  useEffect(() => {
    dispatch(getPlansAction(friendlyName));
  }, [dispatch, applicationType, family]);

  return (
    <>
      <FormControl
        error={showProductError}
        variant="outlined"
        className="product-riders-section__policy-type__form__row--field"
      >
        <InputLabel ref={setProductLabel} id="product-label">
          Product Type
        </InputLabel>
        <Select
          labelId="plan-select-label-plan"
          labelWidth={productLabel?.clientWidth}
          fullWidth
          id="plan-select-plan"
          value={productType.value}
          onBlur={() => setBlurProduct(true)}
          onChange={e => dispatch(changePlanAction(e.target.value as string))}
        >
          {isLoaded(productList)
            ? productList.Data.filter(product => product?.active != false).map((product, index) => (
                <MenuItem value={product.name!} key={index}>
                  {product.name!}
                </MenuItem>
              ))
            : null}
        </Select>
        {showProductError && <FormHelperText>{ErrorMessages.REQUIRED_MESSAGE}</FormHelperText>}
        {isLoading(productList) ? (
          <CircularProgress className="product-riders-section__policy-type__loading-icon" />
        ) : null}
      </FormControl>
    </>
  );
};

export default PlanSelect;
